import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const QuickActions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleAddAsset = () => {
    navigate('/asset-registration');
  };

  const handleBulkImport = () => {
    navigate('/asset-registration?mode=bulk');
  };

  const handleViewAssets = () => {
    navigate('/asset-list');
  };

  const handleLifecyclePlanning = () => {
    navigate('/lifecycle-planning');
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-foreground">{t('dashboard.quick_actions_title')}</h3>
        <p className="text-sm text-muted-foreground">{t('dashboard.quick_actions_subtitle')}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <Button
          variant="outline"
          iconName="Plus"
          iconPosition="left"
          onClick={handleAddAsset}
          className="justify-start"
        >
          {t('dashboard.add_new_asset')}
        </Button>
        <Button
          variant="outline"
          iconName="Upload"
          iconPosition="left"
          onClick={handleBulkImport}
          className="justify-start"
        >
          {t('dashboard.bulk_import')}
        </Button>
        <Button
          variant="outline"
          iconName="Package"
          iconPosition="left"
          onClick={handleViewAssets}
          className="justify-start"
        >
          {t('dashboard.view_all_assets')}
        </Button>
        <Button
          variant="outline"
          iconName="TrendingUp"
          iconPosition="left"
          onClick={handleLifecyclePlanning}
          className="justify-start"
        >
          {t('dashboard.lifecycle_planning')}
        </Button>
      </div>
    </div>
  );
};

export default QuickActions;